import { render, staticRenderFns } from "./pdfShow.vue?vue&type=template&id=2f06e1b4&scoped=true&"
import script from "./pdfShow.vue?vue&type=script&lang=js&"
export * from "./pdfShow.vue?vue&type=script&lang=js&"
import style0 from "./pdfShow.vue?vue&type=style&index=0&id=2f06e1b4&prod&lang=less&scoped=true&"
import style1 from "./pdfShow.vue?vue&type=style&index=1&id=2f06e1b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f06e1b4",
  null
  
)

export default component.exports